import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { OfferFeeMessage } from '../../../../types/OfferFeeMessage';
import { queries } from '../../../common/api/queryKeys/queries';
import { useRole } from '../../../common/hooks/useRole';

export function useOfferTotalFee(
    offerTotal: number,
    currencyCode: string = 'USD',
    enabled: boolean = true
): UseQueryResult<OfferFeeMessage> {
    const role = useRole();

    return useQuery({
        ...queries.offers.totalFee(offerTotal, currencyCode),
        enabled: enabled && (role.isSupplier() || role.isSuperAdmin()),
    });
}
